export const getStyle = (proportions?: number) =>
  (proportions && { paddingBottom: `${proportions}%` }) || {};

export const getProportionUrl = (url: string, proportions: number) =>
  `${url}?w=${820}&h=${Number.parseInt(Math.ceil(820 * (proportions / 100)).toString(), 10)}&crop=true`;
